import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Displays a readonly disclaimer for EMR widgets shared with patients.
 *
 * Intended for reuse across unified charting widgets when the form
 * is rendered in patient-facing readonly mode.
 */
@Component({
  selector: 'fb-emr-readonly-notice',
  templateUrl: './emr-readonly-notice.html',
  styleUrl: './emr-readonly-notice.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmrReadonlyNotice {
  /**
   * Text shown in the notice. Defaults to the approved copy used in unified charting.
   */
  public readonly text = input('Fields are for provider usage only');
}
